/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { styled } from '@mui/system';
import { colorPalette } from '../../../colorPalette';
export const CardContainer = styled('div') `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-inline: ${({ padding }) => padding}px;
  gap: 16px;
  padding-top: 24px;
  height: 100%;
  color: ${colorPalette.gray900};
`;
export const TitleContainer = styled('div') `
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const ClubRContainer = styled('div') `
  display: flex;
  align-self: flex-start;
`;
export const Title = styled('span') `
  font-size: 18px;
  font-weight: 600;
`;
export const CenteredTitle = styled('span') `
  font-size: 18px;
  font-weight: ${({ weight }) => weight};
  text-align: center;
`;
export const ImageContainer = styled('div') `
  position: relative;
  display: flex;
  ${({ isCenter }) => isCenter &&
    `
    justify-content: center;
  `}
  ${({ isHiddenOverflow }) => isHiddenOverflow &&
    `
    overflow: hidden;
  `}
  ${({ bottom }) => bottom &&
    `
    bottom: ${bottom}px;
  `}
  ${({ left }) => left &&
    `
    left: ${left}px;
  `}
`;
export const CheckImageContainer = styled('div') `
  position: relative;
`;
export const Image = styled('img') `
  position: relative;
  left: -20px;
`;
export const TextContainer = styled('div') `
  display: flex;
  flex-direction: column;
`;
export const CircleContainer = styled('div') `
  display: flex;
  border-radius: 25px;
  background-color: #d80000;
  height: 32px;
  width: 32px;
  align-self: center;
  justify-content: center;
  padding: 4px;
`;
export const CircleText = styled('span') `
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-self: center;
`;
export const CheckIcon = {
    color: colorPalette.green700,
    fontSize: '14px',
    background: 'linear-gradient(66.24deg, #F3FFED 29.44%, #D2EAC6 74.07%)',
    height: '32px',
    width: '32px',
    borderRadius: '16px',
    padding: '2px',
    position: 'absolute',
    right: '0px'
};
